import { useMutation } from 'react-query'

import { useCurrentSite } from '../components/SitesProvider'
import request from '../config/axios'

export interface CreateQRSessionData {
  sessionId: string
  patientCaseId?: string
  surveyResponseGroupId?: string
  metadata?: Record<string, unknown>
}

interface CreateQRSessionResponse {
  session_id: string
  status: string
  expires_at: string
}

const useCreateQRSession = () => {
  const trustedSiteId = useCurrentSite()?.id
  const url = '/impacts/qr_sessions'

  return useMutation(
    (data: CreateQRSessionData) => {
      const qrSessionPayload = {
        session_id: data.sessionId,
        patient_case_id: data.patientCaseId,
        survey_response_group_id: data.surveyResponseGroupId,
        metadata: data.metadata || {},
      }
      return request.post<CreateQRSessionResponse>(url, {
        siteIds: [trustedSiteId],
        qr_session: qrSessionPayload,
      })
    },
    {
      onError: (_error) => {
        // QR session creation failed - handled by UI
      },
    },
  )
}

export default useCreateQRSession
